import React from 'react';
import AlertModal from '../modal/AlertModal';

interface ErrorBoundaryProps {
  children: JSX.Element;
  onReset?: () => void;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  isModalOpen: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null, isModalOpen: false };
  }

  /* 에러 발생시 fallback UI 표시하도록 상태 업데이트 */
  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error, isModalOpen: true };
  }

  /* 에러 내용과 발생 위치에 대한 log */
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    if (process.env.NODE_ENV === 'development') {
      console.error('Uncaught error:', error, errorInfo);
    }
  }

  handleCloseBtn = () => {
    this.setState({ hasError: false, error: null, isModalOpen: false });
  };

  // confirm 버튼 활성화시 -> reset 동작
  handleConfirmBtn = () => {
    this.setState({ hasError: false, error: null, isModalOpen: false });
    if (this.props.onReset) {
      this.props.onReset();
    }
  };

  render() {
    if (this.state.hasError) {
      const { isModalOpen, error } = this.state;
      const modalBtn = {
        closeTxt: 'Close',
        isCancelBtn: true // 필요에 따라 설정
      };
      const modalTxt = error || 'An unexpected error occurred.';

      return (
        <AlertModal
          isOpen={isModalOpen}
          closeBtn={{
            onClose: this.handleCloseBtn,
            buttonName: modalBtn.closeTxt
          }}
          {...(modalBtn.isCancelBtn
            ? {
                confirmBtn: {
                  onClose: this.handleConfirmBtn,
                  buttonName: 'Retry'
                }
              }
            : {})}
          confirmBtn={undefined}
        >
          {'Error: ' + (modalTxt || 'An unexpected error occurred.')}
        </AlertModal>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
